import { INavItem } from "../interfaces/common.interface";

export const NAV_MENU_LIST: INavItem[] = [
  {
    levelOneId: "",
    url: "dp",
    title: "Shopee - Damage Protection",
    icon: "security",
    levelTwo: [
      {
        levelTwoId: "",
        url: "claims",
        title: "Claims",
        icon: "receipt",
      },
    ],
  },
  {
    levelOneId: "",
    url: "ew",
    title: "Shopee - Extended Warranty",
    icon: "monitor_heart",
    levelTwo: [
      {
        levelTwoId: "",
        url: "claims",
        title: "Claims",
        icon: "receipt",
      },
      {
        levelTwoId: "",
        url: "policies",
        title: "Policies",
        icon: "verified",
      },
    ],
  },
  {
    levelOneId: "",
    url: "ew",
    title: "TBM - Extended Warranty",
    icon: "monitor_heart",
    levelTwo: [
      {
        levelTwoId: "",
        url: "tbm-policies",
        title: "Policies",
        icon: "verified",
      },
    ],
  },
];
